import { render, staticRenderFns } from "./ProductsSeries.vue?vue&type=template&id=34e00a50"
import script from "./ProductsSeries.vue?vue&type=script&lang=js"
export * from "./ProductsSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports